import { useCallback, useContext } from 'react';
import {
  V3AppsContext,
  V3SelectedAppContext,
} from '../../../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';

const useGetItemNavLink = () => {
  const { selectedProduct } = useContext(V3SelectedAppContext);
  const { availableProductApps } = useContext(V3AppsContext);

  const getItemNavLink = useCallback(
    (app: V3.App, item: V3.Navigation.Item) => {
      if (!selectedProduct) {
        return `/workspaces/${app.urlSlug}/${item.key}`;
      }

      const subAppsThisUserHasAccessTo = availableProductApps.filter((app) =>
        selectedProduct.appIds.includes(app.id),
      );

      if (subAppsThisUserHasAccessTo.length <= 1) {
        return `/apps/${selectedProduct.urlSlug}/${item.key}`;
      }

      return `/apps/${selectedProduct.urlSlug}/${app.urlSlug}/${item.key}`;
    },
    [availableProductApps, selectedProduct],
  );

  return getItemNavLink;
};

export default useGetItemNavLink;
